// extracted by mini-css-extract-plugin
export var container = "d3_g";
export var fadeDiv = "d3_lg";
export var placeholderWrapper = "d3_sL";
export var video = "d3_sM";
export var videoWrapper = "d3_ls";
export var vimeoPlayer = "d3_sN";
export var wrapper = "d3_B";